class Form {
  constructor(document = window.document) {
    this.blocks = document.querySelectorAll('[data-block="form"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Block(block);
      });
    }
  }
}

class Block {
  constructor(block) {
    this.element = $(block);
    this.elements = {
      form: this.element.find('[data-form]'),
      fields: this.element.find('[data-field]'),
      message: this.element.find('[data-message]'),
    };
    this.redirect = this.element.data('redirect');

    this.elements.form.on('submit', (e) => {
      e.preventDefault();
      this.submit(e.target);
    });
  }

  async submit(form) {
    if (this.isLoading()) {
      return;
    }

    this.setAsLoading();

    try {
      const result = await this.send(form);

      this.setAsLoaded();
      this.parse(result.data);

      if (result.success) {
        this.setAsSuccess();
        this.hide();

        if (this.redirect) {
          window.location.href = this.redirect;
        }
      } else {
        this.setAsFail();
      }
    } catch (error) {
      console.error(error);
    }
  }

  async send(form) {
    const data = new FormData(form);
    const recaptcha = window.bvm.recaptcha ? await window.bvm.recaptcha() : null;

    if (recaptcha) {
      data.append('recaptcha', recaptcha);
    }

    const response = await fetch(window.bvm.ajax, {
      method: 'POST',
      body: data,
    });

    if (! response.ok) {
      throw new Error(`[${response.status}] ${response.statusText}`);
    }

    return await response.json();
  }

  parse(response) {
    this.elements.fields.each((i, el) => {
      const field = $(el).data('field');

      if (response.errors && response.errors[field]) {
        $(el).addClass('-invalid');
        $(el).find('[data-error]').html(response.errors[field]);
      } else {
        $(el).removeClass('-invalid');
        $(el).find('[data-error]').html('');
      }
    });

    if (response.message) {
      this.elements.message.html(response.message);
    }
  }

  hide() {
    this.elements.form.remove();
  }

  isLoading() {
    return this.element.hasClass('-loading');
  }

  setAsLoading() {
    this.element.addClass('-loading');
  }

  setAsLoaded() {
    this.element.removeClass('-loading');
  }

  setAsSuccess() {
    this.element.addClass('-success');
    this.element.removeClass('-fail');
  }

  setAsFail() {
    this.element.addClass('-fail');
    this.element.removeClass('-success');
  }
}

$(document).on(`bvm_front_ready`, () => {
  new Form();
});

$(document).on('bvm_blocks_form_init', (event, document) =>  {
  if ('function' === typeof document.querySelectorAll) {
    new Form(document);
  }
})
